import React from "react";
import { useParams } from "react-router-dom";

import MailReadingSurface from "./components/MailReadingSurface";

export default function InboxDetailPage() {
    const { receiptId = "", threadId = "" } = useParams();

    return (
        <section className="mail-hub-inbox-detail-page">
            <MailReadingSurface entry="inbox" receiptId={receiptId} threadId={threadId} />
        </section>
    );
}
